import React from "react";
import "./core-list-kpi-strip.scss";

// Opportunity and Open leads are withdrawn with the demand hook — both read
// /api/core-list/insights, which 500s in production, so both sat on a loading
// skeleton forever. Re-add these two entries when that endpoint is fixed; see
// the note in CoreListTemplate.
const TILES = [
  { key: "total", tone: "default", label: "Core references", caption: "across all brands" },
  { key: "outOfStock", tone: "danger", label: "Out of stock", caption: "no active listing" },
  // "trade price in range" until 2026-10-08, when marketplace listings started
  // counting too — the caption has to name both or it describes half the tile.
  { key: "atTarget", tone: "success", label: "At buy target", caption: "trade or marketplace" },
];

const KpiTile = ({ tone, label, caption, value, isLoading }) => (
  <div className="core-list-kpi">
    <div className="core-list-kpi__label-row">
      <span className={`core-list-kpi__dot core-list-kpi__dot--${tone}`} aria-hidden="true" />
      <span className="core-list-kpi__label">{label}</span>
    </div>
    <div className="core-list-kpi__value">
      {isLoading ? <span className="core-list-kpi__skeleton" /> : (value ?? 0)}
    </div>
    <div className="core-list-kpi__caption">{caption}</div>
  </div>
);

/**
 * CoreListKpiStrip — shared KPI row for Core List + Insights.
 *
 * @param {number} total — count of all Core List records
 * @param {number} outOfStock — records with Active off or no listing
 * @param {number} atTarget — references with ≥1 trade-group price at or under a buy target
 * @param {boolean} [isLoading]
 */
const CoreListKpiStrip = ({ total, outOfStock, atTarget, isLoading = false }) => {
  const values = { total, outOfStock, atTarget };
  return (
    <div className="core-list-kpi-strip">
      {TILES.map((tile) => (
        <KpiTile
          key={tile.key}
          tone={tile.tone}
          label={tile.label}
          caption={tile.caption}
          value={values[tile.key]}
          isLoading={isLoading}
        />
      ))}
    </div>
  );
};

export default CoreListKpiStrip;
